import React, { useState, useEffect } from "react";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import MyVerticallyFileModal from "../imgUpload/fileModal";
import {
  createMonetize,
  getMonetize,
  editMonetize,
  getAllFiles,
  getFilesById,
  publishMonetize,
} from "../../api/api";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { NecStore } from "../../store/necStore";
import Loader from "../loader/loader";
// import { UserLang } from "../../store/userStore";

const Monetize = (props) => {
  const initState = {
    adTag: "",
    adsTxt: "",
    premiumAd: false,
    freemiumAd: false,
  };
  const obj = {
    images: {
      application: "",
      createdBy: "",
      date: "",
      fileName: "",
      filekey: "",
    },
  };

  const [colorSchema, setColor] = useState(initState);
  const role = NecStore.useState((s) => s.setting);
  const [colorCount, setColorCount] = useState("");
  const [colorStatus, setColorStatus] = useState(0);
  const [loading, setLoading] = useState(false);
  const [fileSelect, setFile] = useState(obj);
  const [allFiles, setAllFiles] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  // const lan = UserLang.useState((s) => s.lan);
  const [lan] = useState("ltr");

  const handleChange = (evt) => {
    const value = evt.target.value;
    setColor({
      ...colorSchema,
      [evt.target.name]: value,
    });
  };
  const updateVisiblity = (event) => {
    setColor({
      ...colorSchema,
      [event.target.name]: event.target.checked,
    });
  };

  useEffect(() => {
    const getFile = async () => {
      try {
        const appl = await getAllFiles(100, 0);

        const images = appl.data.images;
        const opt = images.map((item) => ({
          value: item.filekey,
          label: item.fileName,
          key: item.filekey,
          name: item.fileName,
          id: item._id,
        }));

        setAllFiles(opt);
      } catch (error) {}
    };
    const brandFile = async (editing) => {
      /* eslint-disable no-unused-vars */
      if (editing.bannerImage !== null) {
        const results = await getFilesById(editing.adsTxt).then(
          (result) => {
            setFile(result.data);
          },
          (error) => {}
        );
      }
    };
    const colorDetail = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */
      const result = await getMonetize().then(
        (result) => {
          setColor(result.data);
          brandFile(result.data);
          setLoading(false);
        },
        (error) => {
          const obj = {
            status: error.response.data.error.status,
            message: error.response.data.error.message,
          };
          setColorCount(obj.message);
          setColorStatus(obj.status);
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    colorDetail();
    getFile();
  }, []);

  const colorSave = async (event) => {
    setLoading(true);
    event.preventDefault();

    if (colorStatus === 404 || colorCount === "No Color Schema Exists") {
      /* eslint-disable no-unused-vars */
      const result = await createMonetize(colorSchema).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    } else {
      const result = await editMonetize(colorSchema).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
    }
  };

  const publish = async (event) => {
    // setDisable(true);
    if (role.production === true) {
      setLoading(true);
      event.preventDefault();

      /* eslint-disable no-unused-vars */
      const result = await publishMonetize().then(
        (result) => {
          toastr.success("Successfully Published", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
    } else {
      toastr.error("Preview Environment is off", "Error");
    }
    /* eslint-disable no-unused-vars */
  };

  const filterOption = (option, searchText) => {
    if (option.data.name.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  };

  const onChangeItem = (value, evt) => {
    setColor({
      ...colorSchema,
      [evt.name]: value.id,
    });

    const temp_obj = {
      images: {
        application: "",
        createdBy: "",
        date: "",
        fileName: value.name,
        filekey: value.key,
      },
    };

    setFile(temp_obj);
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Monetize Schema
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <form onSubmit={colorSave}>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"premiumAd"}
                              id={"premiumAd"}
                              defaultChecked={colorSchema.premiumAd}
                              onClick={(event) => updateVisiblity(event)}
                              disabled
                            />
                            <label
                              className={
                                lan === "rtl"
                                  ? "float-right custom-control-label not-bold"
                                  : "float-left custom-control-label not-bold"
                              }
                              htmlFor={"premiumAd"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              Show Ads on All Premium Plan
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"freemiumAd"}
                              id={"freemiumAd"}
                              defaultChecked={colorSchema.freemiumAd}
                              onClick={(event) => updateVisiblity(event)}
                              disabled
                            />
                            <label
                              className={
                                lan === "rtl"
                                  ? "float-right custom-control-label not-bold"
                                  : "float-left custom-control-label not-bold"
                              }
                              htmlFor={"freemiumAd"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              Show Ads on a Free and Premium Plan
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            Ad Tag *
                          </label>
                          <input
                            type="text"
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            name="adTag"
                            className="form-control inside-form"
                            placeholder="AdTag"
                            defaultValue={colorSchema.adTag}
                            onChange={handleChange}
                            autoComplete="off"
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="row">
                            {lan === "rtl" && (
                              <div className="col-md-4">
                                <Button
                                  variant="light"
                                  onClick={() => setModalShow(true)}
                                  style={{
                                    width: "100px",
                                    marginTop: "8px",
                                    height: "40px",
                                  }}
                                >
                                  Upload
                                </Button>
                              </div>
                            )}
                            <div
                              className="col-md-8"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <label
                                className={
                                  lan === "rtl" ? "float-right" : "float-left"
                                }
                              >
                                Select File
                              </label>
                              <Select
                                name="adsTxt"
                                className={
                                  lan === "rtl"
                                    ? "form-control inside-select float-right"
                                    : "form-control inside-select float-left"
                                }
                                filterOption={filterOption}
                                options={allFiles}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                                disabled
                              ></Select>
                              <div
                                className="row"
                                style={{
                                  marginTop: "100px",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "20px" }}
                                >
                                  <div>{fileSelect.images.fileName}</div>
                                </div>
                              </div>
                            </div>
                            {!(lan === "rtl") && (
                              <div className="col-md-4">
                                <Button
                                  variant="light"
                                  onClick={() => setModalShow(true)}
                                  style={{
                                    width: "100px",
                                    marginTop: "8px",
                                    height: "40px",
                                  }}
                                >
                                  Upload
                                </Button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <div
                          className={
                            lan === "rtl"
                              ? "float-left btn-group btn-group-md"
                              : "float-right btn-group btn-group-md"
                          }
                          role="group"
                        >
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: "100px", marginRight: "6px" }}
                          >
                            Save
                          </button>
                          <button
                            type="button"
                            onClick={publish}
                            className="btn btn-success"
                            style={{ width: "100px", marginRight: "6px" }}
                            disabled={!role.production === true ? true : false}
                            hidden={!role.production === true ? true : false}
                          >
                            Publish
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
        <MyVerticallyFileModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          allimage={allFiles}
        />
      </section>
    );
  }
};

export default Monetize;
